<template>
    <div class="map-sidepanel" :class="{ open: modelValue }" role="dialog" aria-label="Panneau carte">
        <header class="px-3 py-2 border-bottom d-flex align-items-center justify-content-between">
            <strong>Paramètres</strong>
            <button class="btn btn-sm btn-outline-secondary" @click="$emit('update:modelValue', false)">
                Fermer
            </button>
        </header>

        <div class="p-3 panel-content">
            <!-- Zone header optionnelle (ex: recherche d'adresse) -->
            <div class="mb-3">
                <slot name="header" />
            </div>


            <!-- Layers -->
            <div class="mb-3">
                <div class="text-muted small mb-2">Carte</div>
                <div class="layer-grid">
                    <div v-for="(tp, i) in tileProviders" :key="i" class="layer-card" :class="{ selected: tp.visible }"
                        role="button" tabindex="0" @click="$emit('select-base-layer', tp.name)"
                        @keydown.enter.space="$emit('select-base-layer', tp.name)"
                        :aria-pressed="tp.visible ? 'true' : 'false'" :aria-label="`Sélectionner le fond ${tp.name}`">
                        <div class="layer-thumb" :style="tp.preview ? { backgroundImage: `url(${tp.preview})` } : {}" />
                        <div class="layer-name">{{ tp.name }}</div>
                    </div>
                </div>
            </div>

            <!-- ⬇️ Sections personnalisées injectées par le shell -->
            <div class="custom-sections">
                <slot name="sections" />
            </div>

            <!-- Placeholder pour d'autres options
            <div class="mb-3">
                <div class="text-muted small mb-2">Informations</div>
                <p class="mb-1">Centre: {{ center?.[0]?.toFixed?.(4) }}, {{ center?.[1]?.toFixed?.(4) }}</p>
                <p class="mb-0">Zoom: {{ zoom }}</p>
            </div>-->
        </div>
    </div>
</template>

<script>
export default {
    name: 'MapSidePanel',
    props: {
        modelValue: { type: Boolean, default: false }, // v-model pour open/close
        tileProviders: { type: Array, default: () => [] },
        center: { type: Array, default: () => [0, 0] },
        zoom: { type: Number, default: 13 },
    },
    emits: ['update:modelValue', 'select-base-layer'],
};
</script>

<style scoped>
.map-sidepanel {
    position: fixed;
    /* ne “pousse” pas la page */
    top: calc(var(--app-header-height, 0px) + 1rem);
    left: 1rem;
    width: clamp(260px, 28vw, 320px);
    /* toute la hauteur dispo = viewport - header - marges */
    max-height: calc(100dvh - var(--app-header-height, 0px) - 2rem);
    background: #fff;
    border-radius: .75rem;
    box-shadow: 0 10px 30px rgba(0, 0, 0, .15);
    transform: translateX(calc(-100% - 1rem));
    transition: transform .25s ease;
    z-index: 2000;
    /* ✅ layout interne en colonne : le header garde sa taille, le contenu prend le reste */
    display: flex;
    flex-direction: column;
    /* ✅ on masque tout débordement externe, le scroll se fait DANS .panel-content */
    overflow: hidden;
}

.map-sidepanel.open {
    transform: translateX(0);
}

.panel-content {
    /* ✅ prend tout l’espace restant sous le header */
    flex: 1;
    min-height: 0;
    /* indispensable pour que flex autorise le scroll interne */
    /* scroll natif interne (barre masquée) */
    overflow-y: auto;
    overflow-x: hidden;
    padding-left: .25rem;
    /* évite que le halo des checkboxes soit “collé”/coupé */
    /* Masquer la scrollbar sur tous les moteurs */
    -ms-overflow-style: none;
    /* IE/Edge */
    scrollbar-width: none;
    /* Firefox */
}

.panel-content::-webkit-scrollbar {
    /* Chrome/Safari/Opera */
    width: 0;
    height: 0;
}

/* ---- Layers preview ---- */
.layer-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: .75rem;
}

.layer-card {
    cursor: pointer;
    border-radius: .75rem;
    border: 1px solid rgba(0, 0, 0, .08);
    overflow: hidden;
    box-shadow: 0 4px 12px rgba(0, 0, 0, .06);
    transition: transform .12s ease, box-shadow .12s ease, border-color .12s ease;
    background: #fff;
    outline: none;
}

.layer-card:hover,
.layer-card:focus {
    transform: translateY(-1px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, .10);
    border-color: rgba(0, 0, 0, .15);
}

.layer-card.selected {
    border: 2px solid #0d6efd;
    /* Bootstrap primary */
    box-shadow: 0 8px 24px rgba(13, 110, 253, .2);
}

.layer-thumb {
    width: 100%;
    aspect-ratio: 1 / 1;
    background: linear-gradient(135deg, #e9ecef, #dee2e6);
    background-size: cover;
    background-position: center;
}

.layer-name {
    font-size: .85rem;
    font-weight: 600;
    text-align: center;
    padding: .4rem .5rem .55rem;
    color: #212529;
}

.custom-sections {
    margin-top: 2rem;
    /* ajustable : 1rem / 1.25rem / 1.5rem selon ton goût */
}
</style>
